import { Component } from '@angular/core';

@Component({
  selector: 'app-fieldset-accordion-content',
  templateUrl: './fieldset-accordion-content.component.html',
})
export class FieldsetAccordionContentComponent { }
